import { useEffect, useMemo, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { enableKlarna, klarnaConfig } from '@/utils/configs/payment.config';
import { PaymentTracker } from '@/utils/Tracker';
import cls from 'classnames';
import styles from './index.module.less';

/**
 * 渲染klarna message
 * @param {id} 一个页面上多个标识可做区别
 * @param {number} amount 数量，数量变化会导致组件重渲染
 * @param {object} style 防止重渲染太慢，可设置display=none
 * @param {object} dataKey 可用于控制sdk自动渲染的message样式
 * @param {string} className
 */
function Index(props) {
  const {
    style = {},
    area: {
      country: { code, currency },
    },
    dataKey = 'top-strip-promotion-auto-size',
    auth,
    id,
    className,
    amount: propsAmount,
  } = props;
  const current = klarnaConfig.payment[code];
  const [loaded, setLoaded] = useState(false);
  // 金额以小数点后两位为最小单位，因此都需要乘以100
  const amount = useMemo(() => {
    if (!propsAmount) return 0;
    const _amount = typeof propsAmount === 'string' ? Number(propsAmount.replace(/\$|,|£|€/g, '')) : propsAmount;
    return (_amount * 100).toFixed(0);
  }, [propsAmount]);

  const enable = useMemo(() => {
    return current && enableKlarna({ code, currency });
  }, [code, currency, current]);

  useEffect(() => {
    if (enable) {
      PaymentTracker.klarnaTracker({
        action: `show_KlarnaMsg${id ? '_' + id : ''}`,
      });
    }
  }, [enable]);

  /**
   * 反复查询window.klarna，避免js未下载完全的情况
   */
  function queryWindowKlarna() {
    return new Promise((resolve) => {
      let counter = 0;
      const MAX_COUNTER = 30;
      const timer = setInterval(() => {
        const klarna = window.Klarna;
        counter++;
        if (klarna) {
          resolve(true);
          clearInterval(timer);
        }
        if (counter > MAX_COUNTER) {
          resolve(false);
          clearInterval(timer);
        }
      }, 200);
    });
  }

  /** 金额变动重新查询 */
  useEffect(() => {
    const query = async () => {
      try {
        if (window.Klarna) {
          if (!loaded) {
            window.Klarna.OnsiteMessaging?.on('informationalModalOpened', () => {
              PaymentTracker.klarnaTracker({
                action: `click_KlarnaMsg${id ? '_' + id : ''}`,
              });
            });
          }

          setLoaded(true);
        } else {
          const res = await queryWindowKlarna();
          setLoaded(res);
        }
      } catch (e) {
        auth.dataCollect({
          event: 'klarna.Messages.Error',
        });
      }
    };
    if (!loaded) {
      query();
    }
  }, [amount]);

  useEffect(() => {
    if (enable && loaded) {
      setTimeout(() => {
        window.Klarna?.OnsiteMessaging?.refresh();
      }, 0);
    }
  }, [amount, enable, current, loaded]);
  if (!enable) return null;

  return (
    <div style={style} className={cls(styles.klarnaMsg, className)}>
      <klarna-placement
        id={'klarna_container' + id}
        data-key={dataKey}
        data-locale={current.locale}
        data-currency={current.currency}
        data-purchase-amount={amount}
      />
    </div>
  );
}

export default inject('area', 'auth')(observer((props) => <Index {...props} />));
